import styled, { css } from "styled-components";
import { theme } from "../../../styles/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  text-align: ${(props) => props.align};
  align-items: ${(props) => props.align};
  ${(props) =>
    props.hasBorder &&
    css`
      border-bottom: 1px solid ${props.theme.colors.grey2};
    `}
  h4 {
    margin-bottom: 0;
  }
`;

export const WrapperIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  opacity: 1;
  margin-bottom: 10px;
`;
